import React from 'react';
import { Receipt } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from '@/components/ui/dialog';

export const ConfirmAddonDialog = ({ confirmAddon, onCancel, onConfirm }) => (
  <Dialog open={!!confirmAddon} onOpenChange={onCancel}>
    <DialogContent className="bg-slate-50 border-slate-200 text-slate-900" data-testid="confirm-addon-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Receipt className="w-5 h-5 text-indigo-700" /> Confirmar add-on de denúncias extra
        </DialogTitle>
        <DialogDescription className="text-slate-500">
          {confirmAddon && (
            <>Cliente <strong className="text-slate-900">{confirmAddon.name}</strong>: <strong className="text-slate-900">+{confirmAddon.extra}</strong> denúncias este mês
            {confirmAddon.price > 0 && <> a {confirmAddon.price}€/un = <strong className="text-indigo-700">{confirmAddon.total}€</strong></>}.
            Isto aumenta o limite efetivo e desbloqueia a gestão das denúncias em excesso.</>
          )}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel} className="border-slate-300 text-slate-700" data-testid="cancel-addon-btn">
          Cancelar
        </Button>
        <Button onClick={onConfirm} className="bg-indigo-700 hover:bg-amber-600 text-black" data-testid="confirm-addon-btn">
          Confirmar add-on
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
